import { render } from "./ScadenzePage.vue?vue&type=template&id=840294ee"
import script from "./ScadenzePage.vue?vue&type=script&lang=js"
export * from "./ScadenzePage.vue?vue&type=script&lang=js"

import "./ScadenzePage.vue?vue&type=style&index=0&id=840294ee&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__